<template>
  <CmLineSidebar
    class="loyalty-entity-default-info"
    :class="{'loyalty-entity-default-info-open': selectedEntity.length === 0 || (isEditMode && allSections && allSections.length === 0)}">
    <h4 class="cm-title">
      {{ $t('loyalty.sections.general') }}
    </h4>
    <div v-if="info" class="loyalty-entity-default-info__data">
      <template v-for="(field, index) in general">
        <Field
          :key="index"
          :config="field"
          v-model="info.attributes[field.name]"
          :checkValue="vObj.info.attributes[field.name]"
          :isEditMode="isEditMode"
        />
      </template>
    </div>

    <div v-for="(section) in sections" v-if="values.length !== 0" class="loyalty-entity-default-info__section">
      <h4 class="cm-title">{{ $t(`loyalty.sections.${section.title}`) }}</h4>
      <div :key="index + item" v-for="(item, index) in section.content">
        <Field :config="attributes[item]"
               :isEditMode="false"
               v-model="values[item]"/>

      </div>
    </div>

  </CmLineSidebar>
</template>


<script>
  import CmLineSidebar from "@/components/library/CmLineSidebar.vue";
  import ColorTags from "@/components/ColorTags.vue";
  import {mapState} from "vuex";
  import LoyaltyService from "@/services/LoyaltyService";
  import Field from "@/components/loyalty/components/field/Index.vue";

  export default {
    name: "LoyaltyEntityInfoMasterAccount",

    components: {
      Field,
      ColorTags,
      CmLineSidebar
    },

    props: {
      vObj: Object
    },

    data() {
      return {
        general: [
          {
            name: "Number",
            icon: "info",
            order: 1
          },
          {
            name: "ExternalId",
            icon: "info",
            order: 2
          },
          {
            name: "Description",
            placeholder: this.$t(`loyalty.info.enterAdditionalInformation`),
            icon: "info",
            order: 3
          }
        ],
        sections: [
          {
            "title": "purchases",
            "content": ["Sum", "AllDiscountedSum", "SumAfterDiscounted", "Discount", "Quantity", "AverageCheque", "AverageChequeAfterDiscounted", "LastTransactionOn"]
          },
          {
            "title": "bonusBalance",
            "content": ["Debet", "Credit", "Balance", "ActiveBalance", "HoldPoints"]
          },
          {
            "title": "statusBonusBalance",
            "content": ["StatusDebet", "StatusCredit", "StatusBalance", "StatusActiveBalance", "HoldStatusPoints"]
          },
          {
            "title": "moneyBalance",
            "content": ["MoneyDebet", "MoneyCredit", "MoneyBalance"]
          }
        ],
        attributes: [],
        values: []
      }
    },
    computed: {
      ...mapState({
        allFields: state => state.loyalty.allFields,
        generalSection: state => state.loyalty.generalSection,
        allSections: state => state.loyalty.allSections,
        info: state => state.loyalty.info,
        selectedEntity: state => state.loyalty.selectedEntity,
        isEditMode: state => state.loyalty.isEditMode,
      }),

      fields() {
        return this.allFields && this.generalSection ? this.allFields.filter(field => this.generalSection.find(i => i.name === field.name))
          .map(field => ({
            ...field,
            ...this.generalSection.find(i => i.name === field.name)
          }))
          .filter(i => i.order)
          .sort((a, b) => a.order - b.order) : []
      },
    },
    mounted() {
      this.getSectionsInfo();
    },
    methods: {
      async getSectionsInfo() {
        try {
          const metaData = await LoyaltyService.getEntityMetaData('MasterAccountBalance');
          let {attributes} = metaData;
          this.sections.forEach(section => {
            section.content.forEach(field => {
              this.attributes[field] = {
                ...attributes[field],
                label: "MasterAccountBalance" + field
              }
            })
          })
          this.$set(this.attributes);

          const {id} = this.$route.params;
          if (id) {
            const masterAccountBalance = await LoyaltyService.getRelationships('MasterAccount', id, 'MasterAccountBalance', 'MasterAccountId', 0, '')
            this.values = masterAccountBalance[0].attributes;
          }
        } catch (e) {
          console.log(e);
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .loyalty-entity-default-info {
    padding: 15px 0 15px 20px;
    width: 490px;

    &__data {
      padding-right: 45px;

      &:not(:last-child) {
        margin-bottom: 40px;
      }
    }

    &__section {
      margin-top: 30px;
    }

    .cm-line-sidebar__title {
      transform: rotate(270deg) translate(-80px, -45px);
    }

    .cm-title {
      margin-top: 0;
      margin-bottom: 23px;
    }

    &.cm-line-sidebar--closed {
      padding: 0;
    }
  }

  .client-info {
    &__general {
      &-row {
        &:not(:last-of-type) {
          padding-bottom: 10px;
        }

        &-title {
          &:before {
            padding-right: 5px;
          }
        }

        &-value {
          color: rgba($color: #000000, $alpha: 0.9);
          font-weight: 600;
        }

        &-link {
          border-bottom: 1px solid $color_gray_b1;
          color: $color_green-new;
          font-weight: 600;
          white-space: nowrap;

          &--confirmed {
            position: relative;
            &:after {
              position: absolute;
              content: url('#{$image-path}clients/checked-circle.svg');
              top: -3px;
              right: -15px;
            }
          }
        }

        &--not-found {
          font-size: 14px;
          font-weight: 400 !important;
          color: $color_disabled;
          border: none;
          opacity: 0.4;
        }
      }
    }

    &__segments-item {
      margin-bottom: 10px;
    }

    &__offers {
      &-row {
        padding-bottom: 7px;
      }

      &-link {
        color: $color_green-new;
        cursor: pointer;
        font-weight: 600;
      }
    }

    &__comments-text {
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 3px;
      padding: 15px;
      min-height: 175px;
    }
  }
</style>
